import {deepCopy, isNullOrEmpty} from 'src/app/core/utils/common-functions';
import {DHLCityMaintenanceTableColumn} from './interface/dhl-city-maintenance-table-column';
import {PageInfo} from './../../../../core/models/page-info';
import {GlobalConstants} from './../../../../core/constants/global-constants.constant';
import {CommonDataService} from './../../../../core/services/common-data.service';
import {Option} from './interface/option';
import {Component, Injector, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {SessionBaseComponent} from 'src/app/shared/components/session.base.component';
import {Table} from 'primeng/table';
import {DHLCityMaintenanceTableData} from './interface/dhl-city-maintenance-table-data';
import { SortOrder } from 'src/app/core/interface/sort-order';
import {DHLCityMaintenanceRequest} from './interface/dhl-city-maintenance-request';
import {DHLCityMaintenanceService} from '../../service/dhl-city-maintenance.service';
import {throwError} from 'rxjs';
import {UserPreferenceConstants} from '../../../../core/constants/user-preference-constants.constant';
import {DateTableColumn} from '../../../../core/models/date-table-column';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
@Component({
  selector: 'laas-dhl-city-maintenance',
  templateUrl: './dhl-city-maintenance.component.html',
  styleUrls: ['./dhl-city-maintenance.component.scss']
})
export class DHLCityMaintenanceComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.DHLCityMaintenance;
  currentLang: string = this.laasSetting.language;
  // Status for the Query Form is open or not
  isSearchFormOpen = true;
  // The formGroup for the Query Form part
  searchFormGroup: FormGroup;
  searchParams: any;

  // Options for Facility dropdown list
  facilityOptions: Option[] = [];

  // Status for the loading circle on the table
  isLoading: boolean;
  // Status for enabling a user to edit the data on the table
  isInEditMode: boolean;
  // The table for table part
  @ViewChild('table') table!: Table;
  // All the columns of the table have
  tableColumns: DHLCityMaintenanceTableColumn[] = [
    { field: 'awbNumber', header: 'DHLCityMaintenance.Table.ColumnHeader.AwbNumber', sort: true },
    { field: 'shipperCountryCode', header: 'DHLCityMaintenance.Table.ColumnHeader.ShipperCountryCode', sort: true },
    { field: 'shipperCity', header: 'DHLCityMaintenance.Table.ColumnHeader.ShipperCity', sort: true },
    { field: 'shipperCityMappingLaaSCity', header: 'DHLCityMaintenance.Table.ColumnHeader.ShipperCityMappingLaaSCity', sort: true },
    { field: 'consigneeCountryCode', header: 'DHLCityMaintenance.Table.ColumnHeader.ConsigneeCountryCode', sort: true },
    { field: 'consigneeCity', header: 'DHLCityMaintenance.Table.ColumnHeader.ConsigneeCity', sort: true },
    { field: 'consigneeCityMappingLaaSCity', header: 'DHLCityMaintenance.Table.ColumnHeader.ConsigneeCityMappingLaaSCity', sort: true },
    { field: 'errorMsg', header: 'DHLCityMaintenance.Table.ColumnHeader.ErrorMsg', sort: true }
  ];
  // The columns user choose to display
  selectedTableColumns: DateTableColumn[];
  // Current data on the table
  tableData: DHLCityMaintenanceTableData[] = [];
  // Backup data when data retrieved from the back-end
  backupTableData: DHLCityMaintenanceTableData[] = [];
  // User current selected row on the table
  selectedRow: DHLCityMaintenanceTableData | null;
  // User last selected row on the table
  previousSelectedRow: DHLCityMaintenanceTableData | null;

  // Records for user's operation on the table
  updatedCityList: DHLCityMaintenanceTableData[] = [];

  countryToCitiesCache: Map<string, Option[]> = new Map<string, Option[]>();

  // Table paging info
  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };
  // Table sorting info
  sortOrder: SortOrder = {
    property: 'awbNumber',
    direction: -1
  };

  readonly preferenceKey: string = UserPreferenceConstants.DHLCityMaintenanceTableData;

  constructor(
    private injector: Injector,
    private formBuilder: FormBuilder,
    private commonDataService: CommonDataService,
    private dhlCityMaintenanceService: DHLCityMaintenanceService
  ) {
    super(injector);
    this.isLoading = false;
    this.isInEditMode = false;

    this.searchParams = {
      awbNumberList: [],
    };

    this.searchFormGroup = this.formBuilder.group({
      awbNumberList: []
    });


    this.selectedTableColumns = this.tableColumns;
    this.selectedRow = null;
    this.previousSelectedRow = this.selectedRow;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  chipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchFormGroup.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  searchBtnClick(): void {
    this.isSearchFormOpen = false;
    this.isInEditMode = false;
    this.isLoading = true;
    this.pageInfo.pageIndex = 0;
    this.table.first = 0;
    this.sendSearchRequest();
  }

  sendSearchRequest(): void {
    this.restoreData();
    const getRequest: DHLCityMaintenanceRequest = {
      awbNumberList: this.searchParams.awbNumberList,
      pageIndex: this.pageInfo.pageIndex,
      pageSize: this.pageInfo.pageSize,
      sortOrder: this.sortOrder
    };

    this.dhlCityMaintenanceService.getData(getRequest).subscribe({
      next: (response) => {
        this.table.cancelRowEdit(this.selectedRow);

        if (isNullOrEmpty(response)) {
          throwError(response);
        }

        //  Update table
        if (!isNullOrEmpty(response.content)) {
          this.tableData = deepCopy(response.content) ?? [];

          for (const row of this.tableData) {
            this.loadAndCacheCitiesForCountry(row.shipperCountryCode);
            this.loadAndCacheCitiesForCountry(row.consigneeCountryCode);
          }

          this.backupTableData = deepCopy(this.tableData) ?? [];
          this.selectedRow = this.tableData[0];
        } else {
          this.tableData = [];
          this.backupTableData = [];
          this.selectedRow = null;
        }

        this.previousSelectedRow = this.selectedRow;
        this.updateTableHighlight(this.selectedRow);

        if (this.isInEditMode) {
          this.table.initRowEdit(this.selectedRow);
        }

        // Change page Info
        this.pageInfo.totalRecords = response.totalElements;
        this.pageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
      },
      error: (response) => {
        this.tableData = [];
        this.backupTableData = [];
        this.selectedRow = null;
        this.previousSelectedRow = this.selectedRow;
        this.pageInfo.totalRecords = 0;
        this.pageInfo.totalPages = 0;
        this.toastService.error(this.translateService.instant('DHLCityMaintenance.Toast.GetDataFail') + response.status);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  saveChanges(): void {
    this.confirmationService.confirm({
      header: this.translateService.instant('DHLCityMaintenance.Confirm.Header'),
      message: this.translateService.instant('DHLCityMaintenance.Confirm.Save'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.isLoading = true;

        // Check user's operations on the table
        this.checkUpdatedRow();

        this.dhlCityMaintenanceService.saveCityChanges(this.updatedCityList).subscribe({
          next: () => {
            this.table.cancelRowEdit(this.selectedRow);
            this.isInEditMode = false;

            this.sendSearchRequest();
            this.toastService.success(this.translateService.instant('DHLCityMaintenance.Toast.SaveSuccess'));
          },
          error: response => {
            this.isLoading = false;
            this.updatedCityList = [];
            this.toastService.error(this.translateService.instant('DHLCityMaintenance.Toast.SaveFail') + response.status);
          }
        });
      }
    });
  }

  getCityOptions(countryCode: string): Option[] {
    if(!countryCode){
      return [];
    }
    return this.countryToCitiesCache.get(countryCode) ?? [];
  }

  private loadAndCacheCitiesForCountry(countryCode: string | null | undefined): void {
    if (!countryCode) {
      return;
    }
    if (this.countryToCitiesCache.has(countryCode)) {
      return;
    }

    this.commonDataService.getCityByCountry(countryCode).subscribe({
      next: (cities) => {
        const citiesOptions: Option[] = cities.map((city: any) => ({
          label: `${city.seqNo} - ${city.enName} (${city.enName})`,
          value: city.enName
        }));
        this.countryToCitiesCache.set(countryCode, citiesOptions);
      }
    });
  }

  restoreTableDate(): void {
    this.confirmationService.confirm({
      header: this.translateService.instant('DHLCityMaintenance.Confirm.Header'),
      message: this.translateService.instant('DHLCityMaintenance.Confirm.Restore'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.restoreData();

        // Update table to last saved data
        this.tableData = deepCopy(this.backupTableData) ?? [];
        this.clearTableEdit();

        this.table.initRowEdit(this.selectedRow);
        this.toastService.success(this.translateService.instant('DHLCityMaintenance.Toast.RestoreSuccess'));
      }
    });
  }

  switchEditMode(): void {
    if (!this.isInEditMode) {
      this.isInEditMode = true;
      if (!isNullOrEmpty(this.selectedRow)) {
        this.table.initRowEdit(this.selectedRow);
      }
      return;
    }

    this.confirmationService.confirm({
      header: this.translateService.instant('DHLCityMaintenance.Confirm.Header'),
      message: this.translateService.instant('DHLCityMaintenance.Confirm.Exit'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.isInEditMode = false;
        this.restoreData();

        // Update table to last saved data
        this.tableData = deepCopy(this.backupTableData) ?? [];
        this.clearTableEdit();

        this.toastService.success(this.translateService.instant('DHLCityMaintenance.Toast.ExitSuccess'));
      }
    });
  }

  onRowSelect(rowData: DHLCityMaintenanceTableData): void {
    if (!this.isInEditMode) {
      this.previousSelectedRow = this.selectedRow;
      return;
    }

    // Keep the selectedRow variable is pointing at the user's selected row
    // Whether is select or deselect
    this.selectedRow = rowData;

    // Reselect after user click on the same row
    if (this.previousSelectedRow != null && this.previousSelectedRow.awbNumber === this.selectedRow.awbNumber) {
      this.updateTableHighlight(this.previousSelectedRow);
      return;
    }

    // Change the current selected row to the user's selected row
    this.table.cancelRowEdit(this.previousSelectedRow);
    this.table.initRowEdit(this.selectedRow);
    this.previousSelectedRow = this.selectedRow;
  }

  onTablePageChanging(event: { first: number, rows: number }): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / event.rows;
    this.isLoading = true;
    this.sendSearchRequest();
  }

  onTableSorting(event: { field: string, order: number }): void {
    if (this.tableData.length !== 0) {
      this.sortOrder.property = event.field;
      this.sortOrder.direction = event.order;
      this.isLoading = true;
      this.sendSearchRequest();
    }
  }

  async setPageSize(event: any): Promise<void> {
    await super.ngOnInit();
    this.pageInfo.pageSize = event.rows;
  }

  // Cancel current table's row editing
  private clearTableEdit(): void {
    this.table.cancelRowEdit(this.selectedRow);
    this.selectedRow = this.tableData[0];
    this.previousSelectedRow = this.selectedRow;

    // Avoid the highlighted part leave on the previous row
    this.updateTableHighlight(this.selectedRow);
  }

  private restoreData(): void {
    // Clear user changed action
    this.updatedCityList = [];
    this.table.resetScrollTop();
  }

  private checkUpdatedRow(): void {
    let saveDataIndex = 0;

    if (saveDataIndex < this.tableData.length) {
      // Compare backup table data to current table data
      for (const backupData of this.backupTableData) {
        if (JSON.stringify(this.tableData[saveDataIndex]) !== JSON.stringify(backupData)) {
          this.addToUpdateList(this.tableData[saveDataIndex]);
        }
        saveDataIndex++;
      }
    }
  }

  // Control the selection highlighting back to the row
  private updateTableHighlight(currentRow: DHLCityMaintenanceTableData | null): void {
    if (!currentRow) {
      return;
    }
    this.table.selection = currentRow;
    this.table.selectionKeys = {};
    this.table.selectionKeys[currentRow.awbNumber] = 1;
    this.table.tableService.onSelectionChange();
  }

  private addToUpdateList(rowData: DHLCityMaintenanceTableData): void {
    rowData.updateUser = this.userService.userInfo.userName;
    this.updatedCityList.push(rowData);
  }
}
